import { twMerge } from 'tailwind-merge';

import { Avatar, AvatarFallback, AvatarImage } from '@/_components';

export type AvatarShape = 'circle' | 'rectangle' | 'square';

export interface IconLogoAvatarProps {
  className?: string;
  src?: string;
  name?: string;
  avatarShape?: AvatarShape;
  onClick?: () => void;
  isLarge?: boolean;
}

export const IconLogoAvatar = ({
  src,
  name,
  className,
  isLarge = false,
  avatarShape = 'circle',
  onClick,
}: IconLogoAvatarProps) => {
  return (
    <div className="shrink-0 grow-0">
      <Avatar
        onClick={onClick}
        className={twMerge(
          'border-c-border-muted bg-c-avatar! mx-auto flex items-center justify-center border',
          isLarge ? 'size-128 max-w-full' : 'size-7',
          avatarShape === 'circle' && 'rounded-full',
          avatarShape === 'rectangle' && (isLarge ? 'h-72 w-[23.885rem] rounded-2xl' : 'h-7 w-9 rounded-md'),
          avatarShape === 'square' && (isLarge ? 'rounded-2xl' : 'rounded-md'),
          className
        )}
      >
        <AvatarImage src={src} className="pointer-events-auto object-contain" />
        <AvatarFallback className={twMerge('text-c-card-muted m-auto', isLarge ? '' : 'text-xs')} name={name || ''} />
      </Avatar>
    </div>
  );
};
